module.exports = __webpack_public_path__ + "static/media/home-garden.70f4dbef.jpg";